module.exports = __webpack_public_path__ + "img/failure-icon.1bd98e4a.png";